<template>
  <draggable
    :list="result.children"
    item-key="name"
    @change="changeDrag($event, group.id, result.id)"
  >
    <template #item="{ element, index }">
      <TypificationItem
        :key="index"
        :index="index"
        :item="element"
        :parent="result"
        :name="`Motivo ${index + 1}`"
        :total="totalMotives"
        type="motive"
        @updateTree="updateTree"
        @onToggleStatus="
          handleToggleStatus(
            $event,
            element,
            `Motivo ${index + 1}`,
            group.id,
            result.id,
            element.id
          )
        "
      >
        <template #edit="{ hideMoreOptions }">
          <SubmotiveAdd
            :itemmotive="element"
            :itemgroup="group"
            :itemresult="result"
            @push="handlePush($event, element.children)"
            @click="hideMoreOptions"
          />

          <TypificationForm
            :item="element"
            :disabled="haveForm(result, element)"
            @onChange="handleChange($event, element)"
            @updateTree="updateTree"
            @click="hideMoreOptions"
          />

          <!-- <TypificationIvr -->
          <!--   :item="element" -->
          <!--   :disabled="haveForm(result, element)" -->
          <!--   @onChange="handleChange($event, element)" -->
          <!--   @updateTree="updateTree" -->
          <!--   @click="hideMoreOptions" -->
          <!-- /> -->

          <MotiveEdit
            :item="element"
            :itemgroup="group"
            :itemresult="result"
            @change="handleChange($event, element)"
            @click="hideMoreOptions"
          />

          <a-tooltip>
            <a-button
              type="text"
              @click="
                handleDeleteItem(
                  $event,
                  element,
                  `Motivo ${index + 1}`,
                  group.id,
                  result.id,
                  element.id
                );
                hideMoreOptions();
              "
            >
              <template #icon>
                <DeleteOutlined />
              </template>

              Eliminar motivo
            </a-button>
          </a-tooltip>
        </template>
        <TypificationSubmotive
          :result="result"
          :group="group"
          :motive="element"
          @onChange="handleChange"
          @onDrag="changeDrag"
          @onDelete="handleDeleteItem"
          @onToggleStatus="handleToggleStatus"
          @updateTree="updateTree"
        />
      </TypificationItem>
    </template>
  </draggable>
</template>

<script>
import TypificationItem from "@/app/entities/components/picker/TypificationItem.vue";
import MotiveEdit from "@/app/entities/components/drawers/typifications/TypificationMotiveEdit.vue";
import SubmotiveAdd from "@/app/entities/components/drawers/typifications/TypificationSubmotive.vue";
import TypificationSubmotive from "@/app/entities/components/picker/TypificationSubmotive.vue";
import TypificationForm from "@/app/entities/components/modals/typifications/TypificationForm.vue";
// import TypificationIvr from "@/app/entities/components/modals/typifications/TypificationIvr.vue";
import { defineComponent } from "vue";
import { DeleteOutlined } from "@ant-design/icons-vue";
import draggable from "vuedraggable";
export default defineComponent({
  components: {
    DeleteOutlined,
    TypificationItem,
    MotiveEdit,
    SubmotiveAdd,
    TypificationSubmotive,
    draggable,
    TypificationForm,
    // TypificationIvr,
  },
  props: {
    result: {
      required: true,
      type: Object,
    },
    group: {
      required: true,
      type: Object,
    },
  },
  computed: {
    totalMotives() {
      return this.result.children.length;
    },
  },
  methods: {
    changeDrag($event, ...args) {
      this.$emit("onDrag", $event, ...args);
    },
    handleChange(newItem, oldItem) {
      this.$emit("onChange", newItem, oldItem);
    },
    handlePush(item, array) {
      this.$emit("onPush", item, array);
    },
    handleDeleteItem(...args) {
      this.$emit("onDelete", ...args);
    },
    handleToggleStatus(...args) {
      console.log("handle togge");
      this.$emit("onToggleStatus", ...args);
    },
    updateTree() {
      this.$emit("updateTree");
    },
    haveForm(result, element) {
      if (result.form_id != null) return true;
      if (element.form_id != null) {
        return false;
      } else {
        let haveForm = false;
        if (element.children.find((submotive) => submotive.form_id != null)) haveForm = true;
        return haveForm;
      }
    },
  },
});
</script>

<style></style>
